import { render, staticRenderFns } from "./tableView.vue?vue&type=template&id=55f96238&scoped=true&"
import script from "./tableView.vue?vue&type=script&lang=js&"
export * from "./tableView.vue?vue&type=script&lang=js&"
import style0 from "./tableView.vue?vue&type=style&index=0&id=55f96238&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f96238",
  null
  
)

export default component.exports